import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/SalesOrder/List',
    method: 'post',
    data,
  })
}

export function fetchHistoryList(data) {
  return request({
    url: '/SalesOrder/HistoryList',
    method: 'post',
    data,
  })
}

export function fetchHistoryListForCoach(data) {
  return request({
    url: '/SalesOrder/HistoryListForCoach',
    method: 'post',
    data,
  })
}

export function fetchOutstandingOrderList(data) {
  return request({
    url: '/SalesOrder/OutstandingOrderList',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/SalesOrder/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/SalesOrder/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/SalesOrder/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/SalesOrder/Delete',
    method: 'delete',
    data,
  })
}

export function createPayment(data) {
  console.log('createPayment', data)

  return request({
    url: '/SalesOrder/CreatePayment',
    method: 'post',
    data,
  })
}

export function commissionFetchList(data) {
  return request({
    url: '/SalesOrder/commissionList',
    method: 'post',
    data,
  })
}

export function findFarExpiryDate(data) {
  return request({
    url: '/SalesOrder/FindFarExpiryDate',
    method: 'post',
    data,
  })
}

export function studentFetchList() {
  return request({
    url: '/SalesOrder/StudentList',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
      orderBy: 'id',
      orderDesc: true,
    },
  })
}

export function listCoach(data) {
  return request({
    url: '/SalesOrder/ListCoach',
    method: 'post',
    data,
  })
}

export function uploadSignature(data) {
  return request({
    url: '/SalesOrder/UploadSignature',
    method: 'post',
    data,
  })
}

export function downloadSignature(id) {
  return request({
    url: `/SalesOrder/DownloadSignature/${id}`,
    method: 'get',
    responseType: 'blob',
  })
}

export function showExcel(data) {
  return request({
    url: '/SalesOrder/SalesReportExcel',
    method: 'post',
    data,
  })
}


export function DailySalesRegisterReportExcel(data) {
  return request({
    url: '/SalesOrder/DailySalesRegisterReportExcel',
    method: 'post',
    data,
  })
}
